import type { Entity } from './Entity';
import type { Component } from './Component';

type ComponentClass<T extends Component = Component> = new (...args: unknown[]) => T;

/**
 * Base class for all systems.
 * Systems contain game logic and operate on entities with specific components.
 */
export abstract class System {
  /**
   * Component classes required for an entity to be processed by this system.
   */
  abstract readonly requiredComponents: ComponentClass[];

  /**
   * Called once when the system is added to the world.
   */
  init(): void {}

  /**
   * Called every frame with entities that have all required components.
   * @param entities - Entities matching this system's requirements
   * @param delta - Time since last frame in seconds
   */
  abstract update(entities: Entity[], delta: number): void;

  /**
   * Called when the system is removed from the world.
   */
  destroy(): void {}
}
